<template>
  <div>

    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-card>
      <UsuarioPedidoDialog v-model="dialogUsuario" :usuario="usuarioSeleccionado" />
      <ProductoPedidoDialog v-model="dialogProducto" :producto="productoSeleccionado" />

      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Pedidos Recibidos</v-toolbar-title>
      </v-toolbar>

      <v-card-text>

        <v-text-field
          v-model="buscador"
          placeholder="Ejemplo: 1, 5, 12"
          outlined
        >
          <template v-slot:label>
            <v-icon style="vertical-align: middle">mdi-magnify</v-icon>
            Búsqueda por N° de Comprobante
          </template>
        </v-text-field>

        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead class="thead-dark">
              <tr>
                <th>ID</th>
                <th>N° Comprobante</th>
                <th>Estado</th>
                <th>Cambiar Estado</th>
                <th>Monto Total</th>
                <th>Fecha Registro</th>
                <th>Usuario</th>
                <th>Info</th>
                <th>Ver Detalle</th>
                <th>Eliminar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pedido in pedidosBuscados" :key="pedido.id">
                <td>{{ pedido.id }}</td>
                <td>{{ pedido.comprobante_numero }}</td>
                <td>{{ pedido.estado }}</td>
                <td>
                  <v-select
                    :value="pedido.estado"
                    :items="estadosDisponibles"
                    item-text="text"
                    item-value="value"
                    dense
                    hide-details
                    style="max-width: 180px;"
                    @change="cambiarEstado(pedido.id, $event)"
                  ></v-select>
                </td>
                <td>Gs. {{ formatearPrecio(pedido.monto_total) }}</td>
                <td>{{ pedido.fecha_registro }}</td>
                <td>{{ pedido.user ? pedido.user.name : '—' }}</td>
                <td>
                  <v-btn icon small color="blue" @click="verUsuario(pedido.user)" :disabled="!pedido.user">
                    <v-icon small>mdi-account-circle</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn small color="primary" outlined @click="toggleDetalle(pedido.id)">
                    <v-icon left small>{{ detalleAbierto === pedido.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    {{ detalleAbierto === pedido.id ? 'Ocultar' : 'Ver' }}
                  </v-btn>
                </td>
                <td>
                  <v-btn icon small color="red" @click="eliminarPedido(pedido)" :disabled="pedido.estado === 'pedido-recibido'">
                    <v-icon>mdi-delete-forever</v-icon>
                  </v-btn>
                </td>
              </tr>

              <!-- DETALLE EXPANDIBLE -->
              <tr v-if="detalleAbierto" v-for="pedido in pedidosBuscados" :key="'det-' + pedido.id" v-show="detalleAbierto === pedido.id">
                <td colspan="10" class="pa-3" style="background: #f5f5f5;">
                  <strong class="mb-2 d-block">Detalle del Pedido #{{ pedido.comprobante_numero }}</strong>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Imagen</th>
                          <th>Producto</th>
                          <th>Código Barra</th>
                          <th>Vendedor</th>
                          <th>Cantidad</th>
                          <th>Precio</th>
                          <th>Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="det in pedido.detalle_pedidos" :key="det.id">
                          <td>
                            <v-img
                              v-if="det.producto"
                              :src="serverUrl + 'api/productos/get_img_unico_producto/' + det.producto.id + '/' + det.producto.link_photo"
                              width="45"
                              height="45"
                              contain
                              style="cursor: pointer; border-radius: 4px;"
                              @click="verProducto(det.producto)"
                            ></v-img>
                          </td>
                          <td>{{ det.producto ? det.producto.descripcion : '—' }}</td>
                          <td>{{ det.producto ? det.producto.codigo_barra || '—' : '—' }}</td>
                          <td>{{ det.producto && det.producto.categoria && det.producto.categoria.vendedor ? det.producto.categoria.vendedor.nombre : '—' }}</td>
                          <td>{{ det.cantidad }}</td>
                          <td>Gs. {{ formatearPrecio(det.precio_pedido) }}</td>
                          <td>Gs. {{ formatearPrecio(det.precio_pedido_total) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </tr>

            </tbody>
          </template>
        </v-simple-table>

      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import pedidoService from '@/services/pedidoService';
import { http } from '@/services/config';
import UsuarioPedidoDialog from '@/components/tienda/pedido/UsuarioPedidoDialog.vue';
import ProductoPedidoDialog from '@/components/tienda/pedido/ProductoPedidoDialog.vue';

export default {
  name: 'PedidosAdmin',
  components: { UsuarioPedidoDialog, ProductoPedidoDialog },

  data() {
    return {
      buscador: '',
      pedidos: [],
      detalleAbierto: null,
      dialogUsuario: false,
      usuarioSeleccionado: null,
      dialogProducto: false,
      productoSeleccionado: null,
      serverUrl: http.defaults.baseURL,
      estadosDisponibles: [
        { text: 'Confirmado', value: 'confirmado' },
        { text: 'Pagado', value: 'pagado' },
        { text: 'En preparación', value: 'pedido-en-preparacion' },
        { text: 'En tránsito', value: 'pedido-en-transito' },
        { text: 'Recibido', value: 'pedido-recibido' },
        { text: 'Cancelado', value: 'cancelado' }
      ],
      mensaje: { snackbar: false, text: '', color: '', timeout: 5000, colorBtn: 'white' }
    };
  },

  computed: {
    pedidosBuscados() {
      return this.pedidos.filter(p =>
        String(p.comprobante_numero).includes(this.buscador)
      );
    }
  },

  mounted() {
    this.listarPedidos();
  },

  methods: {
    formatearPrecio(valor) {
      if (!valor) return '0';
      return Math.floor(valor).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    toggleDetalle(pedidoId) {
      this.detalleAbierto = this.detalleAbierto === pedidoId ? null : pedidoId;
    },

    verUsuario(user) {
      if (!user) return;
      this.usuarioSeleccionado = user;
      this.dialogUsuario = true;
    },

    verProducto(producto) {
      if (!producto) return;
      this.productoSeleccionado = producto;
      this.dialogProducto = true;
    },

    async cambiarEstado(pedidoId, nuevoEstado) {
      try {
        await pedidoService.cambiarEstado(pedidoId, nuevoEstado);
        this.mensajeOk('Estado actualizado correctamente');
        this.listarPedidos();
      } catch (error) {
        const msg = error.response?.data?.message || 'Error al cambiar estado';
        this.mensajeError(msg);
      }
    },

    listarPedidos() {
      pedidoService.listarPedidos()
        .then(res => { this.pedidos = res.data.data; })
        .catch(() => { this.mensajeError('Error al cargar los pedidos'); });
    },

    async eliminarPedido(pedido) {
      if (!confirm('¿Desea eliminar el pedido N° ' + pedido.comprobante_numero + '?')) return;
      try {
        await pedidoService.delete(pedido.id);
        this.mensajeOk('Pedido eliminado correctamente');
        this.listarPedidos();
      } catch (error) {
        this.mensajeError('Error al eliminar el pedido');
      }
    },

    mensajeOk(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'success', timeout: 5000, colorBtn: 'white' };
    },

    mensajeError(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'error', timeout: 5000, colorBtn: 'white' };
    }
  }
};
</script>
